import PropTypes from "prop-types";

import LinksList from "@/components/Elements/LinksList";
import { useModelLink } from "@/modules/model-link";

import { UserItem } from "./User.type";

const UsersLinksList = ({ users }) => {
  const { getModelLink } = useModelLink();

  const links = users?.map((user) => ({
    label: user.name,
    to: getModelLink("user", user),
    popover: user.email,
  }));

  return <LinksList links={links} />;
};

UsersLinksList.propTypes = {
  users: PropTypes.arrayOf(UserItem),
};

export default UsersLinksList;
